import InactivityController from './inactivity-controller';
import AlertPopupManager from './popup-manager';

export default function initAlertPopups(): void {
    new AlertPopupManager();
    new InactivityController();
}
